import { RootState } from '@app/redux/root-reducer';

export const selectRoleState = (store: RootState) => store.roleReducer.roles;
export const selectModuleState = (store: RootState) => store.roleReducer.module;
export const selectAddRoleState = (store: RootState) => store.roleReducer.addRole;
export const selectRoleStatusUpdateState = (store: RootState) => store.roleReducer.updateRoleStatus;
